import protobuf from 'protobufjs';

let _root = null;
let _loading = null;

function getRoot() {
  if (_root) return Promise.resolve(_root);
  if (_loading) return _loading;
  _loading = protobuf
    .load(['/proto/inbound.proto', '/proto/outbound.proto'])
    .then(root => { _root = root; return root; });
  return _loading;
}

export async function encodeJoinQueue({ requestId, ticketUuid, shopId, firstName, avatarId, turnstileToken = '', serviceId = '', qrToken = '' }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({
    requestId,
    joinQueue: { ticketUuid, shopId, firstName, avatarId, turnstileToken, serviceId, qrToken },
  });
  return ClientEnvelope.encode(msg).finish();
}

export async function encodeLeaveQueue({ requestId, ticketUuid, shopId, serviceId = '' }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({ requestId, leaveQueue: { ticketUuid, shopId, serviceId } });
  return ClientEnvelope.encode(msg).finish();
}

export async function encodeCallNext({ requestId, shopId, serviceId = '' }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({ requestId, callNext: { shopId, serviceId } });
  return ClientEnvelope.encode(msg).finish();
}

export async function encodeSkipTicket({ requestId, shopId, ticketUuid, serviceId = '' }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({ requestId, skipTicket: { shopId, ticketUuid, serviceId } });
  return ClientEnvelope.encode(msg).finish();
}

export async function encodeFinishTicket({ requestId, shopId, ticketUuid, serviceId = '' }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({ requestId, finishTicket: { shopId, ticketUuid, serviceId } });
  return ClientEnvelope.encode(msg).finish();
}

export async function encodeKioskIssueTicket({ requestId, shopId, serviceId = '', kioskDeviceId }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({
    requestId,
    kioskIssueTicket: { shopId, serviceId, kioskDeviceId },
  });
  return ClientEnvelope.encode(msg).finish();
}

export async function encodeCloseShopForToday({ requestId, shopId, queueIds = [] }) {
  const root = await getRoot();
  const ClientEnvelope = root.lookupType('vqueue.ClientEnvelope');
  const msg = ClientEnvelope.create({
    requestId,
    closeShopForToday: { shopId, queueIds },
  });
  return ClientEnvelope.encode(msg).finish();
}

export async function decodeServerEnvelope(buffer) {
  const root = await getRoot();
  const ServerEnvelope = root.lookupType('vqueue.ServerEnvelope');
  return ServerEnvelope.toObject(ServerEnvelope.decode(new Uint8Array(buffer)), {
    longs: Number,
    defaults: true,
  });
}
